import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '../auth/services/auth.service';
import { BaseComponent } from '../shared/base-components/base.component';
import { NoteViewModel } from './models/views/note-view.model';
import { NoteManageService } from './note-manage.service';
// TODO: Remove dependency on jquery
import * as $ from 'jquery';

@Component({
    selector: 'note',
    templateUrl: './note.html'
})

export class NoteComponent extends BaseComponent {
    // Constants
    private DEFAULT_PRIORITY_TYPE = 2;
    private DEFAULT_RECEIVED_TYPE = 1;

    // inputs
    @Input() countDisplayClass: String;
    @Input() headerText = 'Notes';
    @Input() isAddOnly = false;
    @Input() isReadonly = false;
    @Input() isDeleteDisabled = false;
    @Input() isWip = false;
    @Input() noteIdentificationValue = 0;
    @Input() noteIdentificationTypeId = 0;
    @Input() notes: NoteViewModel[] = new Array<NoteViewModel>();

    // outputs
    @Output()
    public noteSaved: EventEmitter<any>;

    public errors: any = {};
    public newNote: NoteViewModel;
    public showErrorTable = false;
    public showNewNote = false;
    private autoSave = false;

    constructor(private noteManageService: NoteManageService, private authService: AuthService) {
        super();

        this.noteSaved = new EventEmitter<any>();
    }

    ngOnInit() {
        this.initializeNewNote();

        if (this.noteIdentificationValue > 0 && this.isWip == false) {
            this.getNotes(this.noteIdentificationValue.toString(), this.noteIdentificationTypeId.toString());
            this.autoSave = true;
        } else if (this.isWip == true && this.noteIdentificationValue > 0 && this.noteIdentificationTypeId > 0) {
            this.addExistingNotesToArray(this.noteIdentificationValue.toString(), this.noteIdentificationTypeId.toString());
            this.autoSave = false;
        } else {
            this.autoSave = false;
            this.updateNotesCount();
        }
    }

    reInitialize() {
        this.ngOnInit();
    }

    toggleNewNote() {
        this.showNewNote = !this.showNewNote;

        if (this.showNewNote) {
            this.initializeNewNote();
        }
    }

    initializeNewNote() {
        this.newNote = new NoteViewModel();
        this.newNote.noteIdentificationValue = this.noteIdentificationValue;
        this.newNote.noteIdentificationTypeId = this.noteIdentificationTypeId;
        this.newNote.isAlert = false;
        this.newNote.isConfidential = false;
        this.newNote.noteDate = new Date();
        this.newNote.notePriorityTypeID = this.DEFAULT_PRIORITY_TYPE;
        this.newNote.noteReceivedTypeID = this.DEFAULT_RECEIVED_TYPE;
    }

    getNotes(noteIdentificationValue: string, noteIdentificationTypeId: string) {
        if (noteIdentificationValue != undefined && noteIdentificationTypeId != undefined) {
            this.noteManageService.getNotes(noteIdentificationValue, noteIdentificationTypeId).subscribe(
                result => {
                    this.notes = result;
                    this.updateNotesCount();

                    this.notes.forEach(n => {
                        var x = n.noteDate.toString();
                        n.noteDate = new Date(x);
                        n.rowId = this.getNextRowId();

                        n.userIsOriginalAuthor = true; // (this._user.claims.userLoginName == n.updatedBy);
                    });
                },
                e => console.log('error', e)
            );
        }
    }

    /**
     * Add existing notes to notes collection.  Used when in wip.
     * @param noteIdentificationValue
     * @param noteIdentificationTypeId
     */
    addExistingNotesToArray(noteIdentificationValue: string, noteIdentificationTypeId: string) {
        if (noteIdentificationValue != undefined && noteIdentificationTypeId != undefined) {
            this.noteManageService.getNotes(noteIdentificationValue, noteIdentificationTypeId)
                .subscribe(result => {
                    var existingNotes = result;

                    existingNotes.forEach(n => {
                        var x = n.noteDate.toString();
                        n.noteDate = new Date(x);
                        n.rowId = this.getNextRowId();
                        n.userIsOriginalAuthor = true; // (this._user.claims.userLoginName == n.updatedBy);

                        this.notes.push(n);
                    });

                    this.updateNotesCount();
                },
                e => console.log('error', e),
                () => {
                });
        }
    }

    /**
     * Get the next available row ID;
     */
    private getNextRowId() {
        var self = this;

        let rowId = 0;
        for (let i = 0; i < self.notes.length; i++) {
            if (self.notes[i].rowId >= rowId) {
                rowId = self.notes[i].rowId + 1;
            }
        }

        return rowId;
    }

    /**
     * Get the index for the row ID.
     * @param rowId
     */
    private getRowIndex(rowId: number) {
        var self = this;
        var index = 0;

        for (let i = 0; i < self.notes.length; i++) {
            if (rowId == self.notes[i].rowId) {
                return i;
            }
        }

        return null;
    }

    onNoteSaved(note: NoteViewModel) {

        if (this.isWip) {
            note.updatedBy = this.authService.userName;
        }

        if (this.autoSave) {

            this.noteManageService.saveNote(note).subscribe(
                () => this.ngOnInit(),
                e => this.handleValidationResult(e),
                () => {}
            );

            this.showNewNote = false;
        } else {

            if (note.rowId != undefined && note.rowId > 0) {

                const index = this.getRowIndex(note.rowId);
                this.notes.splice(index, 1);
            }

            note.rowId = this.getNextRowId();

            this.notes.push(note);

            this.updateNotesCount();

            this.initializeNewNote();
        }

        this.noteSaved.emit(note);
    }

    onNoteCancelled() {
        this.toggleNewNote();
        this.showErrorTable = false;
    }

    onNoteDeleted(rowId: number) {
        const index = this.getRowIndex(rowId);

        if (this.autoSave) {
            var noteId = this.notes[index].id;
            this.noteManageService.deleteNote(noteId.toString()).subscribe(
                result => {
                    this.ngOnInit();
                },
                e => console.log('error', e),
                () => {}
            );

            this.showNewNote = false;
        } else {
            this.notes.splice(index, 1);

            this.updateNotesCount();

            this.showNewNote = false;
        }
    }

    updateNotesCount() {
        var notesCount = '';
        if (this.notes.length > 0) {
            notesCount = this.notes.length.toString();
        }

        $('.' + this.countDisplayClass).html(notesCount);
    }

    close() {
        this.errors = [];
        this.showErrorTable = false;
    }

    handleValidationResult(err) {
        var defaultError = false;

        if (!err.httpStatus) {
            defaultError = true;
        } else {
            if (err.response.errorResults) {
                this.errors = err.response.errorResults;
                this.showErrorTable = true;
            } else {
                defaultError = true;
            }
        }

        if (defaultError) {
            this.errors = new Array<string>();
            this.errors.push('Server error');
            this.showErrorTable = true;
        }
    }

}
